import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  listData: null,
  pagination: {
    perPage: 10,
    pageNum: 1,
  },
  validationMessage: {
    data: {
      goodReservations: [],
      reservationsToDelete: [],
    },
    errors: undefined,
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
